// Displays information of a Order list
import React, { useEffect } from "react";
import { useStyles } from "./OrderListStyles";
import { appInsightsEvents, trackEvent, useAppStore } from "../../../common";
import { Order } from "@dining/api-client";
import { OrderCard } from "../OrderCard/OrderCard";

interface OrderListProps {
  orderList: Order[];
}
export const OrderList = ({ orderList }: OrderListProps) => {
  const styles = useStyles();
  const context = useAppStore((state) => state.context);
  const appInsights = useAppStore((state) => state.appInsights);

  useEffect(() => {
    trackEvent(appInsights, appInsightsEvents.Usage.ViewComponent, context, {
      componentName: "OrderList",
    });
  }, [context, appInsights]);

  return (
    orderList &&
    orderList.length > 0 && (
      <div className={styles.list} data-testid="OrderList">
        {orderList.map((order: Order) => (
          <OrderCard key={order?.id} order={order} />
        ))}
      </div>
    )
  );
};
